module.exports = __webpack_public_path__ + "static/media/apricot.c27bf1b8.jpg";